<template>
  <div>
    <div class="signingSecurityContractStyle">
      <div class="contentStyle">
        <div class="header">
          <span class="leftLabel">担保合同状态：</span>
          <span class="rightLableInfo">{{this.statusText}}</span>
        </div>
        <div class="clues">
          您的提款申请已审批通过，请先签署《担保服务合同》。
        </div>
        <div class="ContractStyle">
          <Contract
            :list="contractList"
            v-model="agreeState"
            :defaultCheck="false"
            :isForceRead="false"
            :buttonDisAble='buttonDisAble'
            @agree="agree"
            @showPopup="showPopup"
          />
        </div>

      </div>
      <div class="btnBox">
        <Button
          text="去签署"
          type="danger"
          class="nextStep"
          :click="goToNextPage"
          :disabled="!agreeState"
        />
      </div>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import Contract from '@/components/Contract.vue';
import ServerBank from '@/components/ServerBank.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'signingSecurityContract',
  data() {
    return {
      statusText: '未签订',
      contractList: [
        {
          text: '担保服务合同',
          value: 'spdb_guarantee',
        },
      ],
      agreeState: false,
    };
  },
  components: {
    Button,
    Contract,
    ServerBank,
  },
  methods: {

    ...mapMutations('commonForms', ['updateForm']),
    // 后端控制页面跳转
    goToNextPage() {
      this.$loading.show();
      const { orderId } = this.$router.currentRoute.query;
      if (orderId) {
        this.updateForm({
          orderId,
        });
      }
      this.$api.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId'),
      }).then((res) => {
        this.$loading.hide();
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          this.$toast(res.returnMessage || '提交失败');
        }
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },
};
</script>
<style lang="scss" scoped>
.signingSecurityContractStyle {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 15px;
  font-size: 15px;
}
.contentStyle {
  box-shadow: border-box;
  padding-left: 40px;
  text-align: left;
}
.header {
  margin-top: 50px;
}
.leftLabel {
  padding-right: 20px;
}
.clues {
  color: #a6a6a6;
  font-size: 14px;
  margin-top: 20px;
}
.btnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 15px;
}
.nextStep {
  width: 100%;
  padding: 0;
  border-radius: 3px;
  margin-top: 10px;
}
.ContractStyle {
  margin-left: -15px;
  margin-top: 20px;
}
.rightLableInfo {
  color: #ff6538;
}
</style>
